export class PendingApplicantError extends Error {}
